export default {
  API_ENDPOINT: 'https://ancient-bayou-42059.herokuapp.com/api',
  TOKEN_KEY: 'Bearer ',
}

